/* U1 — resolucion de la foto del bundle (galeria de packs en la PDP).
 *
 * Problema historico (todas las PDPs con bundles): el builder genera hasta ~15
 * candidatos de nombre de archivo y se probaban EN SERIE. Casi todos son 404, asi
 * que el primer hover sobre una card tardaba 1-2s; cuando la imagen llegaba el
 * mouse ya se habia ido (token invalidado) y la galeria "no cambiaba". La segunda
 * vez andaba porque el browser ya tenia los 404 en cache.
 *
 * Fix global: probe en PARALELO con resolucion por PRIORIDAD (gana el candidato de
 * indice mas bajo que cargue) + cache de resultados por URL, compartido por toda la
 * pagina. Latencia = 1 round trip en vez de N. Ademas un warm-up al cargar resuelve
 * la foto de todos los packs, asi el primer hover ya sale del cache.
 *
 * Vive en assets/ (no en el snippet) por el limite de 256KB de snippets.
 */
(function () {
  var C = window._u1BpProbe || { ok: Object.create(null), bad: Object.create(null) };
  window._u1BpProbe = C;

  /* Versionado de assets: si existe una version -v3 o -v2 del nombre, gana sobre la
     original. Sirve para reemplazar una foto sin borrar el archivo viejo en Files
     (Shopify no deja sobrescribir, solo borrar y volver a subir). */
  var VERSIONS = ['-v3', '-v2', ''];
  function withVersions(list) {
    var out = [];
    list.forEach(function (src) {
      VERSIONS.forEach(function (v) {
        var u = v ? src.replace(/\.(jpg|jpeg|png|webp)(\?|$)/i, v + '.$1$2') : src;
        if (out.indexOf(u) === -1) out.push(u);
      });
    });
    return out;
  }
  window.u1BundleVersions = withVersions;

  /* Resuelve el primer candidato disponible por prioridad. */
  window.u1BundleProbe = function (candidates, callback, onFail) {
    var list = withVersions((candidates || []).filter(Boolean));
    if (!list.length) { if (onFail) onFail(); return; }
    /* Cache hit sincronico: el de mayor prioridad ya resuelto como OK */
    for (var i = 0; i < list.length; i++) {
      if (C.bad[list[i]]) continue;
      if (C.ok[list[i]]) { callback(list[i]); return; }
      break;
    }
    var pend = list.filter(function (s) { return !C.bad[s]; });
    if (!pend.length) { if (onFail) onFail(); return; }
    var results = pend.map(function () { return 0; }); /* 0 pending · 1 ok · -1 fail */
    var done = false;
    var settle = function () {
      if (done) return;
      for (var k = 0; k < pend.length; k++) {
        if (results[k] === 1) { done = true; callback(pend[k]); return; }
        if (results[k] === 0) return; /* esperar a los de mayor prioridad */
      }
      done = true;
      if (onFail) onFail();
    };
    pend.forEach(function (src, k) {
      if (C.ok[src]) { results[k] = 1; settle(); return; }
      var img = new Image();
      img.onload = function () { C.ok[src] = 1; results[k] = 1; settle(); };
      img.onerror = function () { C.bad[src] = 1; results[k] = -1; settle(); };
      img.src = src;
    });
  };

  /* Overlay de la foto del pack sobre la galeria del producto.
     Guarda a QUE PACK pertenece la imagen visible, para que el customizer pueda
     detectar que quedo desincronizada (antes, si el pack nuevo no tenia foto, la
     del pack anterior se quedaba en pantalla). */
  /* Dos capas: un wrap al 100% del viewport con el fondo de la galeria (tapa la slide de atras:
     con pack activo se ve UNA sola imagen), y adentro el <img> con la escala/corrimiento por
     producto (Smart Light 0.553 / -30px) via transform, igual que siempre. Antes el transform
     iba sobre el unico <img> y achicaba tambien su fondo: se veia la foto del pack como una
     caja sobre el video de la galeria (2026-09-16). */
  var WRAP_CSS = 'position:absolute;inset:0;width:100%;height:100%;z-index:10;pointer-events:none;' +
    'background:var(--u1-pdp-gallery-bg, #f5f5f5);overflow:hidden;';
  var IMG_CSS = 'position:absolute;inset:0;width:100%;height:100%;object-fit:contain;display:block;' +
    'padding:var(--u1-pdp-bundle-overlay-pad, 5%);box-sizing:border-box;' +
    'transform:translateY(var(--u1-pdp-bundle-overlay-shift, 0px)) scale(var(--u1-pdp-bundle-overlay-scale, 1));transform-origin:50% 50%;';
  window.u1BundleOverlay = function (root) {
    var el = null, curSrc = '', curPack = '';
    var viewport = function () { return root.querySelector('[data-u1-pdp-gallery-viewport]'); };
    return {
      el: function () { return el; },
      src: function () { return curSrc; },
      pack: function () { return curPack; },
      show: function (src, alt, duration, pack) {
        if (!src) return;
        curPack = pack || '';
        if (src === curSrc && el && el.parentElement) return;
        var vp = viewport();
        if (!vp) return;
        curSrc = src;
        var dur = duration || 200;
        var wrap = document.createElement('div');
        wrap.className = 'u1-bundle-gallery-overlay-wrap';
        wrap.style.cssText = WRAP_CSS + 'opacity:0;transition:opacity ' + dur + 'ms ease;';
        var img = document.createElement('img');
        img.className = 'u1-bundle-gallery-overlay';
        img.src = src;
        img.alt = alt || '';
        img.style.cssText = IMG_CSS;
        wrap.appendChild(img);
        var old = (el && el.parentElement) ? el : null;
        vp.appendChild(wrap);
        el = wrap;
        window.requestAnimationFrame(function () { wrap.style.opacity = '1'; });
        if (old) window.setTimeout(function () { if (old.parentElement) old.remove(); }, dur + 50);
      },
      hide: function () {
        curSrc = '';
        curPack = '';
        if (!el) return;
        var old = el;
        el = null;
        old.style.opacity = '0';
        window.setTimeout(function () { if (old.parentElement) old.remove(); }, 220);
        var vp = viewport();
        if (vp) {
          window.setTimeout(function () {
            vp.querySelectorAll('.u1-bundle-gallery-overlay-wrap, .u1-bundle-gallery-overlay').forEach(function (o) { o.remove(); });
          }, 250);
        }
      }
    };
  };

  /* Warm-up: resuelve la foto de TODOS los packs en background. Solo puebla el
     cache; nunca toca el overlay ni la galeria. */
  window.u1BundleWarm = function (root, getData) {
    try {
      if (!root || typeof getData !== 'function') return;
      var el = root.querySelector('[data-u1-pdp-bundle-packs]');
      if (!el) return;
      var packs = JSON.parse(el.textContent || '[]');
      if (!Array.isArray(packs) || !packs.length) return;
      packs.forEach(function (bp, i) {
        if (!bp) return;
        window.setTimeout(function () {
          try {
            var data = getData(bp);
            if (data && data.candidates && data.candidates.length) {
              window.u1BundleProbe(data.candidates, function () {}, function () {});
            }
          } catch (_e) {}
        }, 120 * i);
      });
    } catch (_e) {}
  };
})();
